import StateMachine from "slotworks/state-machine/state-machine";
import Logger from "slotworks/utils/logger";
import { RandomRangeInt } from "slotworks/utils/math/random";
import Timer from "slotworks/utils/timer";

class SpinSpammer {

    protected isActive = false;

    public toggle() {
        this.isActive ? this.disable() : this.enable();
    }

    protected enable() {
        this.isActive = true;
        Logger.log("Spin Spammer: Enabled");

        this.startTimer();
    }

    protected startTimer() {
        const randomDelay = RandomRangeInt(100, 1000);

        Timer.setTimeout(() => {
            if (this.isActive) {
                StateMachine.skip();
                this.startTimer();
            }
        }, randomDelay);
    }

    protected disable() {
        Logger.log("Spin Spammer: Disabled");

        this.isActive = false;
    }
}

export default new SpinSpammer();
